// --------------------------------------------------------------------------
// responsiveNav.js
// --------------------------------------------------------------------------
// Uses responsive DOM to move site nav around at different breakpoints
// --------------------------------------------------------------------------

RN.responsiveNav = function() {

  'use strict';

  function init() {
    var firstBreakElements = byBehaviour('nav-break-one'),
        secondBreakHeaderElements = byBehaviour('nav-break-two-header'),
        secondBreakBodyElements = byBehaviour('nav-break-two-body');

    firstBreakElements.responsiveDom({
      appendTo: '[data-element="mobile-nav"]',
      mediaQuery: '(max-width: 1180px)'
    });

    secondBreakHeaderElements.responsiveDom({
      appendTo: '[data-element="mobile-nav-header"]',
      mediaQuery: '(max-width: 567px)'
    });

    secondBreakBodyElements.responsiveDom({
      appendTo: '[data-element="mobile-nav"]',
      mediaQuery: '(max-width: 567px)'
    });
  }

  return {
    init: init
  };

}();